import { forwardRef, type Ref, type SVGProps } from "react";
const IconArchiveOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M29 4H3a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h1v11a3 3 0 0 0 3 3h18a3 3 0 0 0 3-3V14h1a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1m-1 8H4V6h24zm-2 13a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V14h20z"
    />
    <path
      fill="currentColor"
      d="M13 21h6a3 3 0 0 0 3-3 1 1 0 0 0-2 0 1 1 0 0 1-1 1h-6a1 1 0 0 1-1-1 1 1 0 0 0-2 0 3 3 0 0 0 3 3"
    />
  </svg>
);
const ForwardRef = forwardRef(IconArchiveOutlineSVG);
ForwardRef.displayName = "IconArchiveOutline";
export { ForwardRef as IconArchiveOutline };
